import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

export default function CoreSelect({
  id,
  value,
  handleChange,
  options,
  label,
  noLabel,
  disabled,
  fullWidth = true,
  variant,
}) {
  console.log("Options", options, value);

  return (
    <FormControl fullWidth={fullWidth} style={{ marginTop: 8 }}>
      {!noLabel && (
        <InputLabel id={id + "-label"} style={{ marginLeft: -8 }}>
          {label || id || "Select option"}
        </InputLabel>
      )}
      <Select
        sx={{
          "& .MuiSelect-select": {
            padding: 1,
          },
        }}
        variant={variant || "standard"}
        labelId={id + "-label"}
        id={id}
        value={value}
        label={noLabel ? "" : label || id || "Select option"}
        onChange={handleChange}
        disabled={disabled}
      >
        {options?.map((option) => (
          <MenuItem
            value={option.id || option.value}
            key={option.id || option.value}
          >
            {option.label || option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
